import { useState } from 'react';
import crypto from 'crypto-js';

const SsoHandler = () => {
    const [ssodata, setssodata] = useState('');
    const decript_data = async (payload, app) => {
        let ciphertext = await crypto.AES.decrypt(payload, app[0].key).toString(crypto.enc.Utf8);
        if (!ciphertext) {
            ciphertext = await crypto.AES.decrypt(payload, app[1].key).toString(crypto.enc.Utf8);
        }
        setssodata(ciphertext);
    };
    const checkSSO = () => {
        const key = new Promise((resolve) => {
            const sso = [
                {
                    app_id: "66f169ac0c50d97941c02ea5", // Your AI App
                    key: "2dc40a46-021b-4925-852c-df6b1fbf1761",
                },
                {
                    app_id: "66224f9fde24a6c1353de932", // Super admin
                    key: "f69ff908-8607-40ec-9d7f-b0424ab6e8c5",
                },
            ];

            window.parent.postMessage({ message: 'REQUEST_USER_DATA' }, '*');
            const temp = window.addEventListener('message', ({ data }) => {
                if (data.message === 'REQUEST_USER_DATA_RESPONSE') {
                    const sso = [
                        {
                            app_id: "66f169ac0c50d97941c02ea5", // Your AI App
                            key: "2dc40a46-021b-4925-852c-df6b1fbf1761",
                        },
                        {
                            app_id: "66224f9fde24a6c1353de932", // Super admin
                            key: "f69ff908-8607-40ec-9d7f-b0424ab6e8c5",
                        },
                    ];
                    console.log(data.payload, sso, 'sso');
                    decript_data(data.payload, sso);
                } else {
                }
            });
        });
    };
    return {
        SSO: ssodata,
        checkSSO: checkSSO,
    };
};
export default SsoHandler;